<template>
<div v-if="isVisible">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 



<!-- //COURSES  -->
<div class="columns is-centered is-multiline is-gapless" style="margin-bottom:1em;">
<div class="column  is-4">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="course_changed()" v-model="data.cour_CODE" placeholder="code" class="input is-dark has-background-grey-dark has-text-white has-text-centered is-fullwidth"> 
    </div>  

<div class="column is-4 doFontSmallest has-background-grey-dark has-text-white" style="margin-bottom:-.2em;">UNITS</div>
<div class="column is-4 doFontSmallest has-background-grey-dark has-text-white" style="margin-bottom:-.2em;">HOURS</div>
<div class="column is-4 doFontSmallest has-background-grey-dark has-text-white" style="margin-bottom:-.2em;">COST</div>

    <div class="column is-4 is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="course_changed()" v-model="data.cour_UNITS" placeholder="units" class="input has-text-centered is-fullwidth"> 
    </div>
    <div class="column is-4  is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="course_changed()" v-model="data.cour_HOURS" placeholder="hours" class="input has-text-centered is-fullwidth"> 
    </div>
    <div class="column is-4   is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="course_changed()" v-model="data.cour_COST" placeholder="cost" class="input has-text-centered is-fullwidth"> 
    </div>
</div>
</div><!-- END COURSE NAM(s)E  -->

<div class="column  is-6">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="course_changed()" v-model="data.cour_TITRE_F" placeholder="FRENCH DESC" class="input is-fullwidth"> 
    </div>  
    <div class="column is-12  is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="course_changed()" v-model="data.cour_TITRE_E" placeholder="ENGLISH DESC" class="input is-fullwidth"> 
    </div>
 


</div>
</div><!-- END COURSE NAM(s)E  -->

<div class="column  is-1">
<div class="columns is-gapless is-multiline">

  <div class="column has-text-right is-12 has-text-weight-light is-size-6 has-background-grey-lighter" style="margin-bottom:-.2em;"> 
    <button @click="course_delete_confirm()" class="button is-fullwidth"><span class="icon is-small has-text-danger-light"> <i class="fas fa-trash-alt"></i> </span></button>
  </div> 

    <div v-if="data.cour_ID != 0" class="column is-12 has-text-weight-bold is-size-7" style="margin-bottom:-.2em;"> <a @click="course_get_ponderation()"  class="button  has-text-info-light  is-fullwidth"><span class="icon is-small"> <i class="fas fa-th-list"></i> </span></a>   </div>





</div></div>

 <!-- COUR SAVE  -->
    <div v-if="+data.isChanged" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="course_save()" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
    </div>

<!-- SHOW PONDERATION  -->
<div v-if="show_pond" class="column is-12" style="margin-bottom:2em;">
  <CompPedCoursePond :cour_id="data.cour_ID" :key="randomKey()"> </CompPedCoursePond>
</div>

</div>
<!-- END COURSES  -->

</div>
</template>

<script>
import axios from 'axios'
import CompPedCoursePond from "@/views/Admin/Comp_Admin_Ped_Course_Ponderation"

export default {
  name: 'AdminPedCourseCourse',
  props: [ 'data' ],
  components: {CompPedCoursePond},


    data() {
        return {
            isVisible:true,
            isLoading:false,
            show_pond:false,
        }
    },


created() {
    
},



methods: {

course_get_ponderation:function() {
    this.show_pond = !this.show_pond
//   if (this.data.showDetails == true) {this.data.showDetails = false ; return ;}
//   this.data.showDetails = true 
//   this.key_pond += 1 
//   this.cour_id = this.data.cour_ID

},






// course_delete_cancel:function(index) {
//   this.data.doDelete = false
// },

course_changed:function() {
  this.data.isChanged = true
},



course_delete_confirm:function() {

// CHECKIF COURSE IN USE -- IF SO  ---->NO!
var sql = "SELECT group_ID FROM MyMEQ_GROUP WHERE cour_ID = " + this.data.cour_ID
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
        if (!res.data[0]) {
                this.$snotify.confirm('Delete Course? ' , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
                position: "centerCenter",
                    buttons: [
                        {text: 'Yes', action: (toast) => this.course_delete_execute(toast)},
                        {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
                    ]
                });
        } else {
            alert ('Course is in use! To delete this course, please delete all instances from the student(s) course list.')
        }
});

},

course_delete_execute:function(toast) {
this.$snotify.remove(toast.id)

  // CHECK IF NOT SAVED
  if (this.data.cour_ID == 0) {this.isVisible=false; return;}
// REMOVE FROM DB
  var query = "DELETE FROM myMEQ_COUR WHERE cour_ID = " + this.data.cour_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
      this.isVisible=false 
  });

},
//END COURSE DELETE



course_delete_execute_LONG:function(toast) {
this.$snotify.remove(toast.id)


var query

// NEED TO CHECK IF REMOVING FROM PROG/COMP !!!! 

if (this.prog_id != 0) 
{query = 'DELETE FROM MyMEQ_RELATION WHERE prog_ID = ' + this.prog_id + " AND cour_ID = " + this.data.cour_ID  

  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });

} // DELETE FROM THE PROGRAM (NO AEC)


else if (this.comp_id != 0) 
{ query = 'DELETE FROM MyMEQ_COMPETENCE_DETAILS WHERE comp_ID = ' + this.comp_id + ' AND cour_ID = ' + this.data.cour_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });

} // DELETE FROM THE COMPETENCE
else {

  // CHECK IF NOT SAVED
  if (this.data.cour_ID == 0) {this.data_courses.splice(index,1); return;}
// REMOVE FROM DB
  query = "DELETE FROM myMEQ_COUR WHERE cour_ID = " + this.data.cour_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });

} // END CHECK DELETE WHAT

},



course_save:function() {

var query
if (this.data.cour_ID == 0) {
  // INSERT
      query = "INSERT INTO MyMEQ_COUR (cour_CODE) VALUES ('');SELECT MAX(cour_ID) AS newID FROM MyMEQ_COUR"
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.data.cour_ID = res.data[0].newID

var dCost = this.data.cour_COST || 0 


          query = "UPDATE myMEQ_COUR SET " 
          query +=  " cour_CODE = '" + this.data.cour_CODE
          query +=  "', cour_TITRE_F = '" + this.data.cour_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', cour_TITRE_E = '" + this.data.cour_TITRE_E.trim().replace(/'/g,"''")
          query +=  "', cour_UNITS = '" + this.data.cour_UNITS
          query +=  "', cour_HOURS = " + this.data.cour_HOURS
          query +=  ", cour_COST = " + dCost
          query +=  " WHERE cour_ID = " + this.data.cour_ID

          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data.isChanged = false
          });
  });
}
else // UPDATE
{ 
          query = "UPDATE myMEQ_COUR SET " 
          query +=  " cour_CODE = '" + this.data.cour_CODE
          query +=  "', cour_TITRE_F = '" + this.data.cour_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', cour_TITRE_E = '" + this.data.cour_TITRE_E.trim().replace(/'/g,"''")
          query +=  "', cour_UNITS = '" + this.data.cour_UNITS
          query +=  "', cour_HOURS = " + this.data.cour_HOURS
          query +=  ", cour_COST = " + this.data.cour_COST
          query +=  " WHERE cour_ID = " + this.data.cour_ID
          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data.isChanged = false
          });

}

},
// END SAVE 

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},



}

}
</script>


<style scoped>

</style>